module.exports = __webpack_public_path__ + "static/media/CC.8a8caf71.png";